export const DefaultClientProfiles: ClientProfiles = {
    name: '',
    email: '',
    mobile: '',
    age: '',
    gender: '',
    wechat: '',
    consulting_content: '',
    is_have_children: '',
    marital_status: '',
    spouse_age: '',
    children: '',
    problem_description: '',
    is_taking_medicine: '',
    medicine_name: '',
    is_stop_taking_medicine: '',
    reason_of_stop_taking_medicine: '',
    disagnosed_adhd: '',
    disagnosed_date: '',
    spouse_chindren: '',
    isVip: false
}

export const MembershipLevel: { [level: string]: string } = {
    Normal: 'normal',
    VIP: 'vip'
}

export const MembershipLevelName: { [level: string]: string } = {
    [MembershipLevel.Normal]: '注册会员',
    [MembershipLevel.VIP]: 'VIP会员',
}

export const GroupCoachingLevelName: { [level: string]: string } = {
    level1: '团体教练一阶',
    level2: '团体教练二阶'
}

export const GroupCoachingLevelPrice: { [level: string]: number } = {
    level1: 4800,
    level2: 3600
}

export const TheInitialInterviewSuggestionType = {
    'free_course': 'free_course',
    'pay_course': 'pay_course',
    'vip': 'vip',
    'group_coaching': 'group_coaching',
    'one_on_one_coaching': 'one_on_one_coaching',
    'recommends_hospital': 'recommends_hospital',
    'coach_camp': 'coach_camp',
    'follow_wxmp': 'follow_wxmp'
}

export const CourseCategory: { [key: number]: string } = {
    0: '显示免费',
    1: '精品课',
    2: '直播回看',
    3: '大师课'
}

export const CoursePriceLevels = [
    {
        price: 8,
        iap_id: 'course1008',
        name: '午餐直播间回看'
    },
    {
        price: 8,
        iap_id: 'course2008',
        name: '家庭加油站回看'
    },
    {
        price: 50,
        iap_id: 'course3050',
        name: '精品课听课费'
    }, {
        price: 108,
        iap_id: 'course4108',
        name: '爱到底精品课'
    }
]

export const MobileVerifyType = {
    signIn: 0,
    signUp: 1,
    forgetPassword: 2,
    common: 3
}

export const GroupCoachingType: { [key: string]: string } = {
    group: 'ADHD执行力训练团体教练',
    family: '《爱与管教的平衡》父母小组课'
}

export const OneOnOneCoachingType: { [key: string]: string } = {
    personal: '一对一个人教练',
    family: '一对一家庭教练'
}

export const ShareType: { [key: string]: string } = {
    collection: '课程合集',
    course: '课程',
    membership: 'VIP会员',
    coach_camp: '训练营',
    initial_interview: '首次约谈',
    oneonone_coaching: '一对一教练',
    group_coaching: '团体教练',
    common: '公共页面'
}